/* eslint-disable no-prototype-builtins */

/* eslint-disable prefer-template */
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../../components/Box';
import { Button } from '../../../../components/Buttons';
import { EditSquare, TimesSquare, View, Edit, Trash } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { Well } from '../../../../components/Well';
import { selectWorks } from '../../../Api/selectors';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { performAction } from '../../actions';
import { REQUEST_KANBAN_BOARD_COLUMN_CELLS, REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { BaseCellComp } from '../BaseCellComp';
import { Cell } from '../Cell';
import { CellButton, CellButtons } from '../CellButton';
import { assignVehicleTasks, setVehicleProperty, fetchVehicle, setVehicleProperties } from '../../../Vehicles/actions';
import { Label } from '../../../Vehicles/components/VehicleCounterLabel';
import { VehiclePropertyLoadable } from '../../../Vehicles/components/VehiclePropertyLoadable';
import { WithVehicleProperty } from '../../../Vehicles/components/WithVehicleProperty';
import { selectVehicleProperty, selectVehicle } from '../../../Vehicles/selectors';
import { REQUEST_USER } from '../../../Users/constants';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../Vehicles/constants';
import { selectUser } from '../../../Users/selectors';
import { List, Row } from '../../../../components/List';
import { fetchUser } from '../../../Users/actions';
import { WithVehicle } from '../../../Vehicles/components/WithVehicle';
import { DocumentsList } from '../../../Documents/components/documentsList';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import NotificationComponent from '../../../../containers/App/Components/Notification/Notification';
import cn from 'classnames';
import styles from './WS_Default.module.css';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import env from '../../../../env';
import { AppClientId } from '../../../Shared/constants';
import { COUNTER_MAP } from './CounterMap';

import { KanbanVehicleRemarks } from '../../components/KanbanVehicleRemarks';
import { getRemarkType } from '../helpers/getRemarkType';
import { selectUserId, selectWork } from '../../../Api/selectors';
import { getPropByName } from '../../../../utils/props';
import { COLOR_PRIMARY_1 } from '../../../../vars';
import { VehiclePropertyEditableInput } from '../../../Vehicles/components/VehiclePropertyEditableInput';
import { PerformActionButton } from '../PerformActionButton';

let todaydate = new Date().toISOString();

//change this for values of counters
const ranges = {
  MediumSeaGreen: [1, 2],
  DarkOrange: [3, 5],
  Crimson: [6, Infinity],
};

const usercolors = {
  MediumSeaGreen: [0],
  RoyalBlue: [1],
  DarkOrange: [2],
  Crimson: [3],
  Chartreuse: [4],
  DeepPink: [5],
  Goldenrod: [6],
  Teal: [7],
};

dayjs.extend(customParseFormat);
const Container = styled.div`
  font-size: 14px;
  .card-title {
    font-size: 14px;
    text-transform: uppercase;
  }

  .option-buttons .button {
    width: 100%;
  }
  .red-text {
    color: red;
  }

  .manco-list > div {
    margin: 12px 0;
  }
  .triple {
    display: flex;
    gap: 12px;
    margin: 12px 0;
    transition: opacity 0.2s;
    .check {
      transition: opacity 0.2s;
      display: inline-block;
      width: 24px;
      height: 24px;
      border: 1px solid ${COLOR_PRIMARY_1};
      color: ${COLOR_PRIMARY_1};
      text-align: center;
      font-size: 21px;
      line-height: 20px;
    }
    &.triple-0 {
      .check {
      }
    }
    &.triple-1 {
      .check {
        border: 1px solid #3bb78e;
        color: #3bb78e;
      }
    }
    &.triple-2 {
      .check {
        border: 1px solid red;
        text-align: center;
        color: red;
      }
    }
    &.disabled {
      opacity: 0.4;
      .check {
        opacity: 0;
      }
    }
    @media (max-width: 425px) {
      font-size: 12px;
    }
  }
`;

export const TaskAssignable = {
  Teun: '0',
  Arjan: '1',
  Len: '2',
  Stefan: '3',
  Overig: '4',
};

export const TasksAssignableOptions = _.map(TaskAssignable, (value, name) => ({ label: name, value: value }));

const STATE = {
  approve: false,
  regplate_code: '',
  isOpenAddModal: false,
  tasksRemarks: [],
  newRemarkText: '',
  editableRemark: null,
  buttonClicked: false,
};

/* eslint-disable react/prefer-stateless-function */
class HOOI_hoursComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.fetch();
    const { vehicle } = this.props;

    if (vehicle && vehicle.tasksRemarks) {
      try {
        const parsedTasksRemarks = JSON.parse(vehicle.tasksRemarks);
        this.setState({ tasksRemarks: parsedTasksRemarks || [] });
      } catch (error) {
        console.error('Error parsing tasksRemarks JSON:', error);
        // Handle the error gracefully, e.g., set default state or display a message
      }
    }

    if (env.clientId === AppClientId.HILTERMANN) {
      this.setState({
        [this.supplierProps.SUPLIER]: getPropByName(this.props.vehicle, this.supplierProps.SUPLIER),
      });
    }
  }

  reset() {
    if (this.props.vehicleDetails) {
      this.props.onClose();
    }
    this.setState({ ...STATE });
  }

  componentDidUpdate(prevProps) {
    const { vehicle } = this.props;

    if (
      (prevProps.vehicle?.id !== vehicle?.id || prevProps.vehicle?.tasksRemarks !== vehicle?.tasksRemarks) &&
      vehicle &&
      vehicle.tasksRemarks
    ) {
      try {
        const parsedTasksRemarks = JSON.parse(vehicle.tasksRemarks);
        this.setState({ tasksRemarks: parsedTasksRemarks || [] });
      } catch (error) {
        console.error('Error parsing tasksRemarks JSON:', error);
        // Handle the error gracefully, e.g., set default state or display a message
      }
    }
    if (prevProps.vehicle != this.props.vehicle && env.clientId === AppClientId.HILTERMANN) {
      this.setState({
        [this.supplierProps.SUPLIER]: getPropByName(this.props.vehicle, this.supplierProps.SUPLIER),
      });
    }
  }

  get supplierProps() {
    return {
      SUPLIER: `Supplier_${this.props.action.functionName}`,
      SUPLIER_INFORMED: `Supplier_${this.props.action.functionName}_informed`,
    };
  }

  get remarkDate() {
    return dayjs(new Date(Date.now())).format('DD-MM-YYYY HH:mm');
  }

  get doubleCheckProps() {
    let props = [this.supplierProps.SUPLIER_INFORMED];
    return props;
  }

  renderDoubleCheck(name) {
    let val = this.propertyValue(name);
    let state = val == 1 ? 1 : 0;
    return (
      <HBox vCenter key={name}>
        <div
          className={`triple triple-${state} ${this.props.work ? 'disabled' : ''}`}
          onClick={() => this.props.setProperty(this.vehicle?.id, name, state == 0 ? 1 : 0)}
        >
          <VehiclePropertyLoadable name={name}>
            <div className="check">{state == 0 ? '-' : '+'}</div>
          </VehiclePropertyLoadable>
          <div className="label">{this.lbl(`vehicle.property.${name}`)}</div>
        </div>
      </HBox>
    );
  }

  renderEditableVehicleFields() {
    return (
      <VBox>
        {[this.supplierProps.SUPLIER].map(prop => {
          return (
            <HBox key={prop} vCenter gap={'8px'}>
              {this.lbl(`vehicle.property.${prop}`)}
              <VehiclePropertyLoadable name={prop}>
                <div className={styles.buttonLabel}>
                  <div className={styles.labelCompany}>
                    <input
                      className="form-control"
                      type={prop}
                      value={this.state[prop]}
                      onChange={this.onInputChange.bind(this)}
                      name={prop}
                      key={prop}
                      onBlur={() => {
                        this.state[prop] && this.props.setProperty(this.vehicle.id, prop, this.state[prop]);
                        console.log('onBlur', this.state[prop]);
                      }}
                    />
                  </div>
                  <div className={styles.decoratorLabel}>€</div>
                </div>
              </VehiclePropertyLoadable>
            </HBox>
          );
        })}
      </VBox>
    );
  }

  propertyValue(name) {
    return this.props.vehicle[name];
  }

  onSave() {
    const remark = {
      id: Date.now(),
      text: this.state.newRemarkText.trim(),
      name: getPropByName(this.props.loggedUser, 'name'),
      surname: getPropByName(this.props.loggedUser, 'surname'),
      date: this.remarkDate,
      nameTask: this.props.payload.task_name,
    };

    const updatedTasksRemarks = [...this.state.tasksRemarks, remark];
    this.props.setRemark(this.vehicle.id, JSON.stringify(updatedTasksRemarks), () => {
      this.setState(prevState => ({
        ...STATE,
        approve: prevState.approve,
        tasksRemarks: prevState.tasksRemarks,
      }));
      this.props.refreshBoards();
    });
  }

  onEdit(remarkId) {
    const remark = {
      id: remarkId,
      text: this.state.newRemarkText,
      name: getPropByName(this.props.loggedUser, 'name'),
      surname: getPropByName(this.props.loggedUser, 'surname'),
      date: this.remarkDate,
      nameTask: this.props.payload.task_name,
    };

    const tasksRemarks = this.state.tasksRemarks?.filter(remark => remark?.id != remarkId);
    const updatedtasksRemarks = [...tasksRemarks, remark];

    this.props.setRemark(this.vehicle.id, JSON.stringify(updatedtasksRemarks), () => {
      this.setState(prevState => ({
        ...STATE,
        approve: prevState.approve,
        tasksRemarks: prevState.tasksRemarks,
      }));
      this.props.refreshBoards();
    });
  }

  onDelete = remarkId => {
    const updatedTasksRemarks = this.state.tasksRemarks.filter(remark => remark.id !== remarkId);
    this.props.setRemark(this.vehicle.id, JSON.stringify(updatedTasksRemarks));
  };

  reset = () => {
    this.setState({ ...STATE, tasksRemarks: this.state.tasksRemarks });
  };

  renderInitials(name, surname) {
    return (
      <HBox left vCenter>
        <HBox className="initials-wrapper" vCenter left>
          <strong>{name[0]?.toUpperCase()}</strong>
          <strong>{surname[0]?.toUpperCase()}</strong>
        </HBox>
        &nbsp;
        <strong>{name ?? ''}</strong>
        &nbsp;
        <strong>{surname ?? ''}</strong>
      </HBox>
    );
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id, this.state.regplate_code);
  }

  get vehicle() {
    return this.props.cell.vehicle;
  }

  getTaskStatus() {
    let name = this.props.payload?.task_name;
    return this.vehicle[name];
  }

  taskAssignedTo({ task_assigned_to, usercolors }) {
    const assignedToName = Object.keys(TaskAssignable).find(key => TaskAssignable[key] === String(task_assigned_to));

    return (
      <Label count={task_assigned_to} ranges={usercolors}>
        {assignedToName}
      </Label>
    );
  }

  getStatusName() {
    let name = this.props.payload?.task_name;
    if (!name) return '';
    return this.lbl('vehicle.plannable.status.' + this.vehicle[name]);
  }

  get counterTaskName() {
    let countertaskname;
    const task_name = this.props.payload?.task_name;
    if (COUNTER_MAP.hasOwnProperty(task_name)) {
      countertaskname = this.vehicle?.[COUNTER_MAP[task_name]];
    } else {
      countertaskname = '-';
    }

    return countertaskname;
  }

  getLabelColor() {
    switch (this.getTaskStatus()) {
      case '1':
      case '3':
        return 'green';
      case '2':
        return 'yellow';
    }
  }

  update(status) {
    let properties = [];
    if (status == '0') {
      properties?.push({
        propertyName: this.props.payload.task_name + '_done',
        propertyValue: '1',
      });

      properties?.push({
        propertyName: this.props.payload.task_name + '_done_date',
        propertyValue: todaydate,
      });
    }

    this.props.updateVehicleProperties(this.props.vehicle?.id, properties);

    this.props.update(this.vehicle.id, status, () => this.setState({ approve: null }));
  }
  renderAddModal() {
    return (
      <ModalComponent
        className={styles.modal}
        title={this.state.editableRemark ? this.lbl('info.tasksremarks.edit') : this.lbl('info.tasksremarks.add')}
        onClose={() => this.setState({ isOpenAddModal: false })}
      >
        <FormField>
          <textarea
            className="form-control"
            value={this.state.newRemarkText}
            onChange={e => this.setState({ newRemarkText: e.target?.value })}
          />
        </FormField>
        <div className="d-flex gap-2 mt-2 justify-content-center">
          <ButtonComponent
            style={'ButtonSoftEdit'}
            disabled={this.props.work}
            onClick={this.state.editableRemark ? () => this.onEdit(this.state.editableRemark) : this.onSave.bind(this)}
          >
            {this.state.editableRemark ? this.lbl('confirm') : this.lbl('add')}
          </ButtonComponent>
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  renderRemarks() {
    const { tasksRemarks } = this.state;
    const filteredRemarks = tasksRemarks.filter(remark => remark.nameTask);
    return filteredRemarks.map(remark => (
      <Row key={remark?.id}>
        <div className={styles.remarkCard}>
          <HBox className="gap-2" vCenter right>
            <ButtonComponent
              style={'ButtonSoftEdit'}
              size={'btn-sm'}
              onClick={() =>
                this.setState({ isOpenAddModal: true, editableRemark: remark?.id, newRemarkText: remark?.text })
              }
            >
              <Edit />
            </ButtonComponent>
            <ButtonComponent style={'ButtonSoftDelete'} size={'btn-sm'} onClick={() => this.onDelete(remark?.id)}>
              <Trash />
            </ButtonComponent>
          </HBox>
          <VBox className="remark" vCenter>
            {remark?.name && remark?.surname && this.renderInitials(remark?.name, remark?.surname)}
            <div className={styles.remarkText}>
              <h6>{remark?.text}</h6>
            </div>
          </VBox>
          <HBox>
            <div>{remark?.nameTask}</div>
            <div>{remark?.date}</div>
          </HBox>
        </div>
      </Row>
    ));
  }

  renderApprove() {
    if (this.props.work) return <Loader small />;
    const task_name = this.props.payload?.task_name;
    const assigned_to = task_name + '_assigned_to';
    const vehicle = this?.vehicle; // assuming vehicle is a prop
    const TASK_REMARK_TYPE = task_name?.replace('task_', '');

    const task_assigned_to = vehicle?.[assigned_to];
    // console.log('task_assigned_to', task_assigned_to);
    if (!this.state.approve) return null;

    if (this.state.loading) {
      this._t = this.timeout(this.props.onChange, 1000, this._t);
    }

    const documents = vehicle.documents;
    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.props.action.label}>
        <WithVehicle vehicle_id={this.vehicle.id}>
          <VehicleHeader vehicle={this.vehicle} />

          <VBox gap="8px" padding="0 0 8px">
            <div className={styles.editableInputContainer}>
              <VehiclePropertyEditableInput
                classNameInput={styles.editableInput}
                className={styles.editableInputButton}
                propertyName={task_name + '_hours'}
                vehicle_id={this.vehicle.id}
              />
            </div>
            {this.props.workRemarks ? (
              <Loader small />
            ) : (
              <>
                <div>Opmerking toevoegen of wijzigen:</div>
                <KanbanVehicleRemarks
                  readOnly
                  taskName={TASK_REMARK_TYPE}
                  kanbanBoardLabel={this.props.board?.label}
                  vehicleId={this.vehicle.id}
                  loggedUserId={this.props.loggedInUserId}
                />
              </>
            )}
          </VBox>
          <br />

          <div className="d-flex gap-2 mt-3">
            <PerformActionButton
              className={styles.confirmButton}
              action={this.props.action}
              target={this.vehicle}
              onChange={this.reset.bind(this)}
            />
            <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
              {this.lbl('cancel')}
            </ButtonComponent>
          </div>
        </WithVehicle>
      </ModalComponent>
    );
  }

  render() {
    const task_name = this.props.payload?.task_name;
    const vehicle = { ...this.vehicle, [task_name]: this.props.taskPropertyValue };
    const countertaskname = this.counterTaskName;
    console.log(task_name);
    const TASK_REMARK_TYPE = task_name?.replace('task_', '');

    return (
      <Cell className={styles.cell}>
        <Container>
          <WithVehicleProperty
            propertyValue={this.vehicle[task_name]}
            vehicleId={vehicle.id}
            propertyName={task_name}
            alt={<VehicleHeader vehicle={vehicle} />}
          >
            <VehicleHeader
              task_name={this.props.payload?.task_name}
              vehicle={vehicle}
              label={this.getStatusName()}
              labelColor={this.getLabelColor()}
            />

            {/* <Label count={countertaskname} ranges={ranges}>
              {countertaskname}
            </Label> */}

            <CellButtons>
              {this.props.cell.busy ? (
                <Loader small />
              ) : (
                <>
                  {this.props.workRemarks ? (
                    <Loader small />
                  ) : (
                    <KanbanVehicleRemarks
                      readOnly
                      taskName={TASK_REMARK_TYPE}
                      kanbanBoardLabel={this.props.board?.label}
                      vehicleId={this.vehicle.id}
                      loggedUserId={this.props.loggedInUserId}
                    />
                  )}
                  <CellButton
                    onClick={this.setStateFn({ approve: !this.state.approve, regplate_code: vehicle.regplate_code || '' })}
                  >
                    <View />
                  </CellButton>
                </>
              )}
            </CellButtons>
            {this.renderApprove()}
          </WithVehicleProperty>
        </Container>
      </Cell>
    );
  }
}

HOOI_hoursComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    loggedUser: selectUser(ownProps?.loggedUserId),
    taskPropertyValue: selectVehicleProperty(ownProps.cell.vehicle.id, ownProps.payload?.task_name),
    work: selectWorks([
      `${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle.id}`,
      REQUEST_USER,
      `${REQUEST_VEHICLE_PROPERTY_UPDATE}-tasksRemarks`,
      REQUEST_VEHICLE_PROPERTY_UPDATE + ownProps.vehicle?.id,
    ]),
    vehicle: selectVehicle(ownProps.cell.vehicle.id),
  });
function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      // dispatch(fetchUser(ownProps?.loggedUserId));
    },

    assign(id, callback) {
      dispatch(
        assignVehicleTasks(ownProps.cell.vehicle.id, `${id}`, true, ownProps.payload?.task_name, () => {
          dispatch(refreshBoards());
          callback();
        }),
      );
    },
    refreshBoards: () => dispatch(refreshBoards()),

    setRemark(vehicle_id, dto, callback) {
      dispatch(setVehicleProperty(vehicle_id, 'tasksRemarks', dto, callback));
    },
    confirm(vehicle_id, regplate_code) {
      dispatch(performAction(ownProps.action.id, vehicle_id, { regplate_code }));
    },
    setProperty(vehicle_id, name, value) {
      dispatch(setVehicleProperty(vehicle_id, name, value));
    },
    update(vehicle_id, status, callback) {
      dispatch(
        setVehicleProperty(vehicle_id, ownProps.payload.task_name, status, result => {
          callback?.();
          ownProps.onChange();
        }),
      );
    },
    updateVehicleProperties(vehicleId, properties, callback) {
      dispatch(setVehicleProperties(vehicleId, properties, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const HOOI_hours = compose(withConnect, withRouter)(HOOI_hoursComp);
